import CheckinDetails from './CheckinDetails.container';

export default CheckinDetails;
